import api from "./api";

export const getWallets = async () => {
  return api.get("/v1/cp/wallets");
};

export const addWallet = async (params) => {
  return api.post("/v1/cp/wallets/otp", params);
};

export const updateWallet = async (id, params) => {
  return api.patch("/v1/cp/wallets/otp/" + id, params);
};

export const deleteWallet = async (id, otp) => {
  return api.delete("/v1/cp/wallets/otp/" + id, { params: { otp } });
};
